import * as React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Box } from '@material-ui/core';
import { formatMoney } from '../../../../services/util/formatNumber';

const AmountField = (props) => {
  const { record, source, symbol, sx } = props;

  const amount = get(record, source);
  const suffix = typeof symbol === 'function' ? symbol(record) : symbol;

  return <Box sx={sx}>{amount !== undefined && amount !== null ? formatMoney(amount, suffix) : '-'}</Box>;
};

AmountField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  symbol: PropTypes.string,
};
AmountField.defaultProps = {
  record: {},
};

export default React.memo(AmountField);
